import { render, staticRenderFns } from "./InGame.vue?vue&type=template&id=13f47b88&"
import script from "./InGame.vue?vue&type=script&lang=js&"
export * from "./InGame.vue?vue&type=script&lang=js&"
import style0 from "./InGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f47b88')) {
      api.createRecord('13f47b88', component.options)
    } else {
      api.reload('13f47b88', component.options)
    }
    module.hot.accept("./InGame.vue?vue&type=template&id=13f47b88&", function () {
      api.rerender('13f47b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/announcement/InGame.vue"
export default component.exports